import { isProd } from '@telialt/utils/src/helpers';

const EXCAVATION_PERMIT_PROD_FORM_ID = '261261943651356';
const EXCAVATION_PERMIT_TEST_FORM_ID = '261733706717360';

export const EXCAVATION_PERMIT_FORM_ID = isProd() ? EXCAVATION_PERMIT_PROD_FORM_ID : EXCAVATION_PERMIT_TEST_FORM_ID;
export const EXCAVATION_PERMIT_IFRAME_ID = `JotFormIFrame-${EXCAVATION_PERMIT_FORM_ID}`;
export const EXCAVATION_PERMIT_IFRAME_SRC = `https://form.jotform.com/${EXCAVATION_PERMIT_FORM_ID}`;
export const EXCAVATION_PERMIT_IFRAME_SELECTOR = `iframe[id='${EXCAVATION_PERMIT_IFRAME_ID}']`;
export const JOTFORM_EMBED_HANDLER_SCRIPT_ID = 'jotform-embed-handler';
export const JOTFORM_EMBED_HANDLER_SCRIPT_SRC = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
